import angular from 'angular';
import template from './webcam-blocked-non-chrome.html';
import './webcam-blocked-non-chrome.scss';
class WebcamBlockedNonChromeController {
    constructor(Browser) {
        this.Browser = Browser;
    }
    $onInit() {
        this.setArticleUrl();
    }
    setArticleUrl() {
        this.articleUrl = this.Browser.getHelpArticleUrl();
    }
}
const webcamBlockedNonChrome = {
    template,
    bindings: {},
    controller: WebcamBlockedNonChromeController,
};
export default angular
    .module('doxy.videoChat.userMediaStatus.common.components.webcamBlockedNonChrome', [])
    // webcam-blocked-non-chrome
    .component('webcamBlockedNonChrome', webcamBlockedNonChrome).name;
